import moment from 'moment' // → moment-with-locales via alias in vite.config (così locale('it') funziona)

// Port di globalFilters.js (Vue 2) → plugin Vue 3.
// In Vue 3 i `filters` nei template non esistono: si espongono come funzioni su
// app.config.globalProperties.$filters, mantenendo nei template la sintassi
// {{ $filters.xxx(value) }} (refactor minimo in Fase 4).
moment.locale('it')

const currency = (rawValue, decimals = 2) => {
  if (typeof rawValue !== 'number' && !rawValue) return ' '
  const value = Number(rawValue)
  if (!Number.isFinite(value) || Number.isNaN(value)) return '-'
  if (decimals === 0) {
    return Math.round(value / 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  return (value / 1).toFixed(decimals).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

const quantity = (rawQuantity) => {
  if (rawQuantity === null) return ''
  const q = (String(rawQuantity).trim() || '0').replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  if (q === '0') return q
  return q.indexOf(',') !== -1 ? q : `${q},000`
}

export const filters = {
  sanitizer: (value) => {
    if (!value) return ' '
    return value
  },
  date: (value, sourceFormat, format) => {
    if (!value || !sourceFormat) return ' '
    return moment(value, sourceFormat).format(format || 'DD/MM/YYYY')
  },
  capitalize: (value) => {
    if (!value) return ' '
    const stringToCapitalize = value.toString()
    return stringToCapitalize
      .split(' ')
      .map((word) => `${word.slice(0, 1).toUpperCase()}${word.slice(1, word.length).toLowerCase()}`)
      .join(' ')
  },
  currency,
  quantity,
  currencyLite: (value) => {
    if (typeof value !== 'number' && !value) return ' '
    return currency(Number(value), 0)
  },
  oneDecimal: (value) => currency(value, 1),
  quantityLite: (rawQuantity) => {
    const quantityValue = quantity(rawQuantity)
    const valueParts = quantityValue.split(',')
    return valueParts[0]
  },
  percentage: (value) => {
    if (!value && typeof value !== 'number') return ''
    return `${currency(value)}%`
  },
  percentageLite: (value) => {
    if (!value) return ''
    const percentageValue = currency(Math.ceil(Number(value)))
    const valueParts = percentageValue.split(',')
    return `${valueParts[0]}%`
  },
  abbreviation: (value) => {
    if (Number(value) > 999999) {
      return `${Math.sign(Number(value)) * ((Math.abs(Number(value)) / 1000000).toFixed())}mil`
    } else if (Number(value) > 999) {
      return `${Math.sign(Number(value)) * ((Math.abs(Number(value)) / 1000).toFixed())}k`
    }
    const val = value.toString().split('.')
    return `${val[0]}`
  },
  decimalAbbreviation: (value) => {
    if (Number(value) > 999999) {
      return `${Math.sign(Number(value)) * ((Math.abs(Number(value)) / 1000000).toFixed(1))}mil`
    } else if (Number(value) > 999) {
      return `${Math.sign(Number(value)) * ((Math.abs(Number(value)) / 1000).toFixed(1))}k`
    }
    const val = value.toString().split('.')
    return `${val[0]}`
  },
}

export default {
  install(app) {
    app.config.globalProperties.$filters = filters
  },
}
